import Header from '../components/layout/Header';
import Content from '../components/layout/Content';
import { PageGrid } from '../components/PageComponent';
import ShortcutsModal from '../components/ShortcutsModal';
import { PortfolioEvaluatorContextProvider } from '../contexts/PortfolioEvaluatorContext';
import PortfolioEvaluatorMap from '../components/portfolio-evaluator/Map';
import PortfolioEvaluatorHeader from '../components/portfolio-evaluator/Header';
import ControlPanel from '../components/portfolio-evaluator/ControlPanel';
import RightMenu from '../components/portfolio-evaluator/RightMenu';

const PortfolioEvaluatorView = () => {
  return (
    <PortfolioEvaluatorContextProvider>
      <PageGrid>
        <ControlPanel />
        <Header>
          <PortfolioEvaluatorHeader />
        </Header>

        <Content noPadding className="flex-row">
          <PortfolioEvaluatorMap />
          <RightMenu />
        </Content>
      </PageGrid>

      <ShortcutsModal />
    </PortfolioEvaluatorContextProvider>
  );
};

export default PortfolioEvaluatorView;
